export default "__VITE_ASSET__36d1529a__"